const o="bento_";export{o as PREFIX};
//# sourceMappingURL=constants.js.map
